export default __webpack_public_path__ + "static/media/status-wrong.17bd7960.svg";